// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__cjxz5","OrderButton":"BuildControls_OrderButton__R_mOD","enable":"BuildControls_enable__1e2C-"};